import { CapoPlugin } from "/home/philip/work/general/clifton-bootcamp/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];